<template>
  <authorization-form></authorization-form>
</template>

<script>
  import AuthorizationForm from './authorizationForm'
  export default {
    name: "AuthorizationRegister",
    components: {
      AuthorizationForm
    }
  }
</script>
